import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, unref as _unref } from "vue"
import _imports_0 from '@/assets/withdraw/withdraw_bg.png'


const _hoisted_1 = { class: "withdraw_container" }
const _hoisted_2 = { class: "channel_text" }
const _hoisted_3 = { class: "channel_list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "balance_container" }
const _hoisted_6 = { class: "balance_text" }
const _hoisted_7 = { class: "balance_value" }
const _hoisted_8 = { class: "sub_container" }
const _hoisted_9 = { class: "input_text" }
const _hoisted_10 = { class: "btn_container" }

import CustomHeader from '../components/common/customHeader.vue';
import { ref } from 'vue'
import InputField from '../withdraw/components/inputField.vue';
import { PayChannel } from '@/types/common';
import WithdrawPopup from '../../themeOne/withdraw/withdrawPopup.vue';
import { formatCurrency } from '@/utils/commonFunction';
import { WithdrawViewData } from '@/view/withdraw/supportScript';
import MainButton from '../components/common/mainButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'withdrawView',
  props: {
    dataSet: {}
  },
  emits: ['confirmWithdraw','selectChannel','inputValueChange'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit


const props = __props

const selectChannel = (item: PayChannel) => {
    emits('selectChannel',item)
}

const inputValueChange = (value: any) => { 
    emits('inputValueChange',value)
}

const confirmWithdraw = () => {
    emits('confirmWithdraw')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomHeader, {
      text: _ctx.$t('common.sake')
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "top-banner" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: ""
        })
      ], -1)),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('common.paymentChannel')) + "：", 1),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet?.channelList, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["channel_card", _ctx.dataSet?.activeChannel.id == item.id ? 'active_channel' : '']),
            key: item.name,
            onClick: ($event: any) => (selectChannel(item))
          }, _toDisplayString(item.name), 11, _hoisted_4))
        }), 128))
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "line" }, null, -1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('withdraw.myBalance')) + ":", 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(formatCurrency)(_ctx.dataSet?.balanceAmount)), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('withdraw.withdrawalAmount')), 1),
        _createVNode(InputField, {
          modelValue: _ctx.dataSet?.selectedAmount,
          labelText: _ctx.$t('withdraw.valueLabel'),
          onValueChanged: inputValueChange
        }, null, 8, ["modelValue", "labelText"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(MainButton, {
          title: _ctx.$t('common.sake'),
          activeStatus: _ctx.dataSet?.activeButton,
          onClick: confirmWithdraw
        }, null, 8, ["title", "activeStatus"])
      ])
    ])
  ], 64))
}
}

})